import { graphql } from "gatsby";
import React from "react";
import ArticleFeed from "../components/articlefeed";

import Layout from "../components/layout";
import RelatedContent from "../components/relatedcontent";
import SEO from "../components/seo";

const nlp = require("../images/nlp.jpeg");

const NaturalLanguageProcessingNewsPage = ({ data }: any) => {
  data.allPrismicArticle.edges.sort(
    (a: any, b: any) =>
      new Date(b.node.data.date).valueOf() -
      new Date(a.node.data.date).valueOf()
  );
  return (
    <Layout>
      <SEO title="NLP News" description="" lang="en" meta={[]} />
      {/* Banner Header */}
      <div
        className="container banner right white"
        style={{ backgroundImage: `url(${nlp})` }}
      >
        <h1>NLP</h1>
      </div>

      {/* News Section */}
      <div className="container">
        <h2>Latest News</h2>
        <div className="row">
          <ArticleFeed data={data} />
          <div className="col-lg-4">
            <RelatedContent />
          </div>
        </div>
      </div>
    </Layout>
  );
};
export const query = graphql`
  query {
    allPrismicArticle(filter: { tags: { in: "NLP" } }) {
      edges {
        node {
          tags
          uid
          data {
            date
            header_image {
              url
            }
            header_image_caption {
              text
            }
            title {
              text
            }
            author {
              text
            }
          }
        }
      }
    }
  }
`;

export default NaturalLanguageProcessingNewsPage;
